var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",style:({ minHeight: _vm.pageHeight + 'px' })},[_c('iframe',{staticStyle:{"width":"100%","height":"500px"},attrs:{"src":"http://mp.weixin.qq.com/s/D3Of4s6IOKTYlgRwYbSpow","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }